module.exports = __webpack_public_path__ + "img/australian_beer_production.6e30666c.jpg";